module.exports = __webpack_public_path__ + "img/mail-2.db16ad11.svg";